const map = document.getElementById('map');
const $counter = $('.js-counter-results');
const $noResultsMessage = $('.js-no-results');
const $results = $('#results');
const templateHTML = $('#template').html();
let markersArray = [];

if (map && window.storeArrays.length > 0) {
  const geocoder = new google.maps.Geocoder();
  const positionsArray = [];

  // Default coordinates of Australia
  const startLatLng = new google.maps.LatLng(-25.274399, 133.775131);
  const mapOptions = {
    zoom: 5,
    center: startLatLng,
    mapTypeControl: false
  };

  const storeMap = new google.maps.Map(map, mapOptions);
  google.maps.event.trigger(storeMap, 'resize');

  function storeLatLng(currentAddress) {
    return new Promise((resolve, reject) => {
      geocoder.geocode({ address: currentAddress }, function(results, status) {
        if (status == 'OK') {
          resolve(results[0].geometry.location);
        } else {
          reject('error');
        }
      });
    });
  }

  const infoWindow = new google.maps.InfoWindow();

  for (let i = 0; i < window.storeArrays.length; i++) {
    let currentLatLng = '';

    storeLatLng(window.storeArrays[i].address)
      .then(function(result) {
        currentLatLng = result;
      })
      .catch(function() {
        if (window.storeArrays[i].lat != '' && window.storeArrays[i].lng != '') {
          currentLatLng = new google.maps.LatLng(window.storeArrays[i].lat, window.storeArrays[i].lng);
        } else {
          currentLatLng = false;
        }
      })
      .then(function() {
        if (currentLatLng === '' || !currentLatLng) {
          return;
        }

        positionsArray.push(currentLatLng);

        const marker = new google.maps.Marker({
          position: currentLatLng,
          map: storeMap,
          title: window.storeArrays[i].name,
          icon: window.mapMarker
        });

        const contentString = `
        <div class="tooltip">
          <div class="tooltip__content">
            <h6>${window.storeArrays[i].name}</h6>
            <adddress>${window.storeArrays[i].address}</adddress>
            <p><strong>PH:</strong> <a href="tel:${window.storeArrays[i].phoneClear}">${window.storeArrays[i].phone}</a></p>
          </div><!-- /.tooltip__content -->
          <figure class="tooltip__image">
            <img src="${window.storeArrays[i].image}" alt="" />
          </figure><!-- /.tooltip__image -->
        </div><!-- /.tooltip -->`;

        google.maps.event.addListener(marker, 'click', function() {
          infoWindow.close();
          infoWindow.setContent(contentString);
          infoWindow.open(storeMap, this);
        });

        markersArray.push(marker);
      });
  }

  function storeAddress(address, distance) {
    geocoder.geocode({ address: address }, function(results, status) {
      let currentLocation;

      if (status == 'OK') {
        currentLocation = results[0].geometry.location;
        storeMap.setCenter(currentLocation);
      } else {
        return false;
      }

      var nearMarkers = [];
      const bounds = new google.maps.LatLngBounds();

      for (let j = 0; j < window.storeArrays.length; j++) {
        const distInit = Number(distance.match(/\d+/)[0]) * 1000;
        const perimeter = google.maps.geometry.spherical.computeDistanceBetween(currentLocation, positionsArray[j]);

        bounds.extend(positionsArray[j]);
        storeMap.fitBounds(bounds);

        if (distInit >= perimeter) {
          window.storeArrays[j].distance = (perimeter / 1000).toFixed(2);
          nearMarkers.push(window.storeArrays[j]);
        }
      }

      $counter
        .text(nearMarkers.length)
        .parent()
        .removeClass('hidden');

      if (nearMarkers.length > 0) {
        $results
          .find('div')
          .empty()
          .remove();
        $noResultsMessage.addClass('hidden');

        renderStores(nearMarkers);
      } else {
        $results
          .find('div')
          .empty()
          .remove();
        $noResultsMessage.removeClass('hidden');
      }
    });
  }

  function renderStores(storesArray) {
    for (let i = 0; i < storesArray.length; i++) {
      let store = templateHTML.toString();

      store = store.replace(/\|\|index\|\|/g, storesArray[i].index);
      store = store.replace(/\|\|storeName\|\|/g, storesArray[i].name);
      store = store.replace(/\|\|storeAddress\|\|/g, storesArray[i].address);
      store = store.replace(/\|\|storeDistance\|\|/g, storesArray[i].distance);

      if (storesArray[i].phoneClear != '') {
        store = store.replace(/\|\|storePhoneClear\|\|/g, storesArray[i].phoneClear);
      } else {
        store = store.replace(/\|\|storePhoneClear\|\|/g, '');
      }

      if (storesArray[i].phone != '') {
        store = store.replace(/\|\|storePhone\|\|/g, storesArray[i].phone);
      } else {
        store = store.replace(/\|\|storePhone\|\|/g, '');
      }

      if (storesArray[i].image != '') {
        store = store.replace(/\|\|storeImage\|\|/g, storesArray[i].image).replace(/\|\|classesImage\|\|/g, 'store__image');
      } else {
        store = store.replace(/\|\|storeImage\|\|/g, '').replace(/\|\|classesImage\|\|/g, 'store__image hidden');
      }

      $results.append($(store));
    }
  }

  $('.js-form-map form').on('submit', function(event) {
    event.preventDefault();

    const $this = $(this);
    const zipValue = 'AUS ' + $this.find('#field-zip').val();
    const distanceValue = $this.find('#field-distance').val();

    storeAddress(zipValue, distanceValue);
  });

  $(document).on('click', '.store', function(event) {
    event.preventDefault();

    google.maps.event.trigger(markersArray[$(this).attr('data-marker-index')], 'click');
  });
}



// WEBPACK FOOTER //
// ./../src/assets/js/map.js